import { render, staticRenderFns } from "./LaboratorioComponente.vue?vue&type=template&id=480a1948"
import script from "./LaboratorioComponente.vue?vue&type=script&lang=js"
export * from "./LaboratorioComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports